import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

/**
 * Wraps routes that require authentication.
 *
 * Props:
 *   children - the route content to render
 *   roles    - optional array of allowed roles (e.g. ['admin', 'team']).
 *              If user's role isn't in the list, redirect to /pipeline.
 */
export function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div style={{
                display: 'grid', placeItems: 'center', height: '100vh',
                color: 'var(--color-ink-soft)',
            }}>
                <span className="spinner" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // Role check — redirect to pipeline if user lacks required role
    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/pipeline" replace />;
    }

    return children;
}
